// src/eventBus.js
import Vue from 'vue';
export const EventBus = new Vue();



// WEBPACK FOOTER //
// ./src/request/eventBus.js